import { TEXT_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForTextElement = createTestId(TEXT_DISPLAY_NAME);
